module.exports = __webpack_public_path__ + "assets/img/banner.e7726e68.jpg";